module.exports = __webpack_public_path__ + "img/domestic-collection.705e1d8c.svg";